const OPENING_TAG = "<3b-context>\n";

export function wrapPlatformContext(content: string): string {
  return `${OPENING_TAG}${content}\n</3b-context>`;
}

export function isPlatformContextEntry(entry: {
  systemMessage?: { text: string } | null;
}): boolean {
  return entry.systemMessage?.text.startsWith(OPENING_TAG) ?? false;
}
